import CategoryDetails from './CategoryDetails'

export default CategoryDetails
